import Api from '../helpers/api';

export const techniquesService = {
    getTechniqueCategories,
    getTechniques,
    getTechnique,
    countTechniques,
    postTechnique,
    putTechnique,
    deleteTechnique
};

async function getTechniqueCategories(cancelToken) {
    const sessionStorageData = sessionStorage.getItem('technique-categories');
  if (sessionStorageData) {
        try {
      const cached = JSON.parse(sessionStorageData);
      if (Array.isArray(cached) && cached.length > 0) return cached;
    } catch {
      sessionStorage.removeItem('technique-categories');
        }
    }

  const response = await Api.get('/preset/anesthetic-techniques/categories', { cancelToken });
  if (Array.isArray(response) && response.length > 0) {
    sessionStorage.setItem('technique-categories', JSON.stringify(response));
  }
  return Array.isArray(response) ? response : [];
}

async function getTechniques(filters, page, pageSize, cancelToken) {
  const { search, ...requestFilters } = filters;
  const params = {
    ...requestFilters,
    name: search,
    page,
    size: pageSize,
  };
  const response = await Api.get('/preset/anesthetic-techniques', { params, cancelToken });

  return response;
}

async function countTechniques(filter, cancelToken) {
    const { search, ...requestFilters } = filter;
    const params = {
        ...requestFilters,
        name: search
    }
  return Api.get('/preset/anesthetic-techniques/count', { params, cancelToken });
}

async function getTechnique(id) {
  return Api.get(`/preset/anesthetic-techniques/${id}`);
}

async function postTechnique(technique) {
  return Api.post('/preset/anesthetic-techniques', technique);
}

async function putTechnique(id, technique) {
  return Api.put(`/preset/anesthetic-techniques/${id}`, technique);
};

async function deleteTechnique(id) {
  return Api.delete(`/preset/anesthetic-techniques/${id}`);
}
